export default {
    container: {
        padding: '30px 30px',
        fontSize: '1em'
    }
}